import { render, staticRenderFns } from "./latest_post.vue?vue&type=template&id=36102a9e&scoped=true&"
import script from "./latest_post.vue?vue&type=script&lang=js&"
export * from "./latest_post.vue?vue&type=script&lang=js&"
import style0 from "./latest_post.vue?vue&type=style&index=0&id=36102a9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36102a9e",
  null
  
)

export default component.exports